   <template>
  <!--公用弹框-->
  <div class="popbox" id="popbox-tishi1" style="display: block">
    <div class="popbox-inner">
      <div class="popbox-header">{{title}}</div>
      <div class="popbox-body">
        <p class="yld-reslut-icon warning"></p>
        <p>{{content}}</p>
      </div>
      <div class="popbox-footer">
        <div class="yld-footer-btns clearfix">
          <button class="yld-footer-btn yld-footer-btn-white" type="button" @click="cancel();">取消</button>
          <button class="yld-footer-btn" type="button" @click="ensure();">确定</button>
        </div>
      </div>
    </div>
  </div>
  <!--//公用弹框-->
</template>

<script>
import $ from "jquery";

export default {
  data() {
    return {
      title: null,
      content: null,
      cancelFunc: null,
      ensureFunc: null
    };
  },
  methods: {
    cancel() {
      if (this.cancelFunc != null) {
        this.cancelFunc();
      }
      $("#popbox-tishi1").remove();
    },
    ensure() {
      if (this.ensureFunc != null) {
        this.ensureFunc();
      }
      $("#popbox-tishi1").remove();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/MessageBox/ConfirmBox.vue